import { Modal, Typography } from '@yimoka/antd';
import { useEffect, useRef, useState } from 'react';
import { registerSW } from 'virtual:pwa-register';

import { useTranslation } from '@/locales/i18n';

const updateInterval = 60 * 60 * 1000;

/** 管理宿主壳 Service Worker；业务 remote 的版本更新由独立版本表处理。 */
export function PwaUpdatePrompt() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const registrationRef = useRef<ServiceWorkerRegistration | undefined>(undefined);
  const updateSWRef = useRef<((reloadPage?: boolean) => Promise<void>) | undefined>(undefined);

  useEffect(() => {
    // Vite 开发态不注册 Service Worker，避免旧构建缓存干扰 host 和 remote 热更新。
    if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;

    const updateSW = registerSW({
      immediate: true,
      onNeedRefresh() {
        setOpen(true);
      },
      onRegisteredSW(_swURL, registration) {
        registrationRef.current = registration;
      },
      onRegisterError(error) {
        console.error('Tenant web service worker registration failed:', error);
      },
    });
    updateSWRef.current = updateSW;

    const checkUpdate = () => {
      void registrationRef.current?.update();
    };
    const timer = window.setInterval(checkUpdate, updateInterval);
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') checkUpdate();
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return (
    <Modal
      destroyOnHidden
      cancelText={t('Update:later')}
      mask={{ closable: false }}
      okText={t('Update:refreshNow')}
      open={open}
      title={t('Update:shell.title')}
      trigger={false}
      width={420}
      zIndex={9999}
      onCancel={() => setOpen(false)}
      onOk={() => {
        void updateSWRef.current?.(true);
      }}
    >
      <Typography.Paragraph style={{ margin: 0 }}>
        {t('Update:shell.description')}
      </Typography.Paragraph>
    </Modal>
  );
}
